var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"reset--list-style card-list"},_vm._l((_vm.list),function(ref){
var id = ref.id;
var gender = ref.gender;
return _c('li',{key:id,staticClass:"card-list__item"},[_c('CardItem',{staticClass:"card-list__link",attrs:{"gender":gender}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }